import { ringsVariants } from './Rings.variants'

export interface RingsProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'solid' | 'gradient'
  accentColor?: 'none' | 'yellow' | 'green' | 'blue'
}

export const Rings = ({
  variant = 'solid',
  accentColor = 'none',
  className,
  ...props
}: RingsProps) => {
  const sizes: ('sm' | 'md' | 'lg' | 'xl')[] = ['sm', 'md', 'lg', 'xl']

  return (
    <>
      {sizes.map((size, i) => (
        <span
          className={ringsVariants({ variant, accentColor, size, className })}
          // eslint-disable-next-line react/no-array-index-key -- Using index as key is safe here because sizes array is static and order does not change
          key={i}
          {...props}
        />
      ))}
    </>
  )
}

Rings.displayName = 'Rings'
